var map = {
	"./allies.tsx": "./src/ts/pages/allies.tsx",
	"./blog.tsx": "./src/ts/pages/blog.tsx",
	"./contact.tsx": "./src/ts/pages/contact.tsx",
	"./detailBlog.tsx": "./src/ts/pages/detailBlog.tsx",
	"./gallery.tsx": "./src/ts/pages/gallery.tsx",
	"./home.tsx": "./src/ts/pages/home.tsx",
	"./landing.tsx": "./src/ts/pages/landing.tsx",
	"./legals.tsx": "./src/ts/pages/legals.tsx",
	"./login.tsx": "./src/ts/pages/login.tsx",
	"./participanteform.tsx": "./src/ts/pages/participanteform.tsx",
	"./ranking.tsx": "./src/ts/pages/ranking.tsx",
	"./register.tsx": "./src/ts/pages/register.tsx",
	"./session.tsx": "./src/ts/pages/session.tsx",
	"./solution.tsx": "./src/ts/pages/solution.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/ts/pages sync recursive ^\\.\\/.*\\.tsx$";